@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

@input-border: 1px solid @usps-pickup-page--input--border-color;
@grid-gap: 8px;

.pickup-content {
  width: 100%;

  h3 {
    margin-top: 48px;
    margin-left: 16px;
  }
}

.pickup-reminder {
  font-size: 14px;
  width: 75%;
  margin-left: 24px;
  padding: 4px 8px 16px;
}

.reminder-text {
  color: @usps-pickup-page--reminder--text-color;
  font-size: 14px;
  font-weight: 900;
  margin-left: -8px;
  grid-area: text;
}

.reminder-wrapper {
  align-items: start;
  display: grid;
  grid-template: 'services details' / 240px auto;
  border-bottom: 2px solid @usps-pickup-page--reminder--border-color;
  padding: 4px 8px 16px;
}

.reminder-services {
  grid-area: services;
  display: grid;
  grid-template-columns: 2fr 1fr;
  row-gap: @grid-gap;
  width: 240px;
}

.reminder-details {
  grid-area: details;
  display: grid;
  grid-template-columns: 1fr 2fr;
  row-gap: @grid-gap;
  width: 480px;
}

.reminder-label {
  font-weight: 700;
}

.reminder-instructions {
  line-height: 16px;
}

.wrapper {
  display: grid;
  grid-template:
    'services details'
    'address .' / 352px 352px;
  width: 75%;
  column-gap: 48px;
}

.group {
  border: 8px solid @usps-pickup-page--group--border-color;
  margin: 0 8px 0 20px;
  padding-bottom: 8px;
}

.group-header {
  text-align: left;
  border-bottom: @input-border;
  font-weight: 500;
  margin-bottom: 8px;
  padding: 4px 0;
  font-size: 16px;
}

.service-section {
  padding: 0 8px 8px;
  min-width: 400px;
  display: grid;
  grid-template-columns: 50% 50%;
  gap: @grid-gap;
  align-items: center;
}

.details-section {
  align-items: center;
  display: grid;
  gap: @grid-gap;
  grid-template-columns: 40% 60%;
  padding: 0 8px 8px;
}

.label {
  text-align: right;
}

.static-label {
  text-align: left;
}

.num-input {
  width: 48px;
  align-self: start;
}

.weight-input {
  width: 100%;
}

.toggler {
  background: @usps-pickup-page--toggler--background-color;
  border: @input-border;
  border-radius: 4px;
}

.address-section {
  align-items: center;
  display: grid;
  grid-template-columns: 35% 65%;
  gap: @grid-gap;
  padding: 0 8px 8px;
  width: 100%;

  .address-input input {
    width: 128px;
    border: @input-border;
  }
}

.address {
  padding: 8px 0 0 32px;
  line-height: 24px;
  font-weight: 600;
  color: @usps-pickup-page--address--text-color;
  grid-column: span 2;
}

.static-address {
  grid-column: span 2;
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  padding: 8px;
}

.button {
  text-align: right;
  align-self: end;
  > button {
    width: 160px;
  }
}

.helper-text {
  margin: 8px 8px 32px 0;
  padding: 8px 0 0 32px;
  line-height: 20px;
}

.helper-text-bold {
  font-weight: 700;
}

.tooltip {
  display: inline-block;
}

.tooltip-icon {
  height: 16px;
  width: 16px;
  vertical-align: baseline;
}

.static {
  font-size: 16px;
  min-height: 32px;
  display: inline-block;
  padding: 8px;
  padding-left: 16px;
  font-weight: 600;
}

.pickup-placeholder {
  display: flex;
  flex-direction: column;
  font-size: 24px;
  height: 80%;
  justify-content: center;
  padding: 4px 0;
  margin: auto;
  text-align: center;
  width: 100%;
}

@media (max-width: 1199px) {
  .wrapper {
    display: grid;
    grid-template:
      'services'
      'details'
      'address' / 512px;
    width: 75%;
  }

  .service-section,
  .address-section {
    grid-template-columns: 40% 60%;
  }
}
